export default __webpack_public_path__ + "static/media/pm25.4d743cc8.svg";